
import { Injectable } from '@angular/core';
import * as globalConstant from './../global_constant';

declare var ttq:any


@Injectable({
  providedIn: 'root'
})
export class TiktokService {

  constructor() {
    
  }
sendPurchaseTracking(itemEvent,tikTokData){        

    ttq.track(itemEvent, tikTokData,() => {

        // Tracking error callback
      });
   
   
  }


}
